import React from 'react';
import { theme } from '../components/theme';

export const Footer = ({ onNavigate }) => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    products: [
      { label: 'Diff Insight', path: '/products/DiffInsight' },
      { label: 'RCA Migration', path: '/RcaMigration' },
      { label: 'CRM Platform', path: '/CRM' },
    ],
    company: [
      { label: 'About Us', path: '/about' },
      { label: 'Careers', path: '/careers' },
      { label: 'Contact', path: '/contact' },
    ],
    support: [
      { label: 'Help Center', path: '/help' },
      { label: 'Documentation', path: '/docs' },
      { label: 'Privacy Policy', path: '/privacy' },
    ],
  };

  return (
    <footer
      style={{
        backgroundColor: theme.colors.primary.navy,
        color: theme.colors.neutral.white,
      }}
    >
      <div
        style={{
          maxWidth: '1280px',
          margin: '0 auto',
          padding: `${theme.spacing['4xl']} ${theme.spacing.lg}`,
        }}
      >
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: theme.spacing.xl,
            marginBottom: theme.spacing['2xl'],
          }}
        >
          <div>
            <h3
              style={{
                fontSize: theme.typography.fontSize.xl,
                fontWeight: theme.typography.fontWeight.bold,
                marginBottom: theme.spacing.md,
              }}
            >
              Aptify
            </h3>
            <p
              style={{
                fontSize: theme.typography.fontSize.base,
                color: 'rgba(255, 255, 255, 0.8)',
                lineHeight: theme.typography.lineHeight.relaxed,
                margin: 0,
              }}
            >
              Enterprise solutions for modern businesses
            </p>
          </div>

          <div>
            <h4
              style={{
                fontSize: theme.typography.fontSize.base,
                fontWeight: theme.typography.fontWeight.semibold,
                marginBottom: theme.spacing.md,
              }}
            >
              Products
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: theme.spacing.sm }}>
              {footerLinks.products.map((link) => (
                <a
                  key={link.path}
                  onClick={() => onNavigate(link.path)}
                  style={{
                    fontSize: theme.typography.fontSize.sm,
                    color: 'rgba(255, 255, 255, 0.8)',
                    textDecoration: 'none',
                    cursor: 'pointer',
                    transition: `color ${theme.transitions.fast}`,
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.color = theme.colors.primary.orange)}
                  onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(255, 255, 255, 0.8)')}
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4
              style={{
                fontSize: theme.typography.fontSize.base,
                fontWeight: theme.typography.fontWeight.semibold,
                marginBottom: theme.spacing.md,
              }}
            >
              Company
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: theme.spacing.sm }}>
              {footerLinks.company.map((link) => (
                <a
                  key={link.path}
                  onClick={() => onNavigate(link.path)}
                  style={{
                    fontSize: theme.typography.fontSize.sm,
                    color: 'rgba(255, 255, 255, 0.8)',
                    textDecoration: 'none',
                    cursor: 'pointer',
                    transition: `color ${theme.transitions.fast}`,
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.color = theme.colors.primary.orange)}
                  onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(255, 255, 255, 0.8)')}
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4
              style={{
                fontSize: theme.typography.fontSize.base,
                fontWeight: theme.typography.fontWeight.semibold,
                marginBottom: theme.spacing.md,
              }}
            >
              Support
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: theme.spacing.sm }}>
              {footerLinks.support.map((link) => (
                <a
                  key={link.path}
                  onClick={() => onNavigate(link.path)}
                  style={{
                    fontSize: theme.typography.fontSize.sm,
                    color: 'rgba(255, 255, 255, 0.8)',
                    textDecoration: 'none',
                    cursor: 'pointer',
                    transition: `color ${theme.transitions.fast}`,
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.color = theme.colors.primary.orange)}
                  onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(255, 255, 255, 0.8)')}
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div
          style={{
            borderTop: '1px solid rgba(255, 255, 255, 0.2)',
            paddingTop: theme.spacing.lg,
            textAlign: 'center',
          }}
        >
          <p
            style={{
              fontSize: theme.typography.fontSize.sm,
              color: 'rgba(255, 255, 255, 0.6)',
              margin: 0,
              lineHeight: theme.typography.lineHeight.relaxed,
            }}
          >
            © {currentYear} Aptify. All rights reserved. | SOC 2 Type II Certified | ISO 27001
            Compliant
          </p>
        </div>
      </div>
    </footer>
  );
};
